import { Input, message, Select } from "antd";
import { INVENTORY_INGREDIENT_UNIT } from "../../../constant/constants";
import { useState } from "react";

export default function IngredientInputs({ records, ingredient = {}, updateIngredientField = () => {} }) {
  const { ingId, ingredients } = records;
  const [itemName, setItemName] = useState(Object.keys(ingredient).length > 0 ? ingredient.name : "");
  const [itemUnit, setItemUnit] = useState(
    Object.keys(ingredient).length > 0 ? ingredient.unit : INVENTORY_INGREDIENT_UNIT[0].value
  );
  const [itemMinStock, setItemMinStock] = useState(Object.keys(ingredient).length > 0 ? ingredient.minStock : "");

  const DECIMAL_INPUT_RE = /^$|^\d+\.?\d{0,2}$|^\.\d{0,2}$/;
  const INTEGER_RE = /^\d+$/;

  function onHandleItemName(e) {
    const tempName = e.target.value;
    if (tempName.length > 100) {
      message.warning(
        <p className="font-p_regular text-[12px]">
          You have reached your limit! Please make it less than
          <span className="text-red-500"> 100 character</span>.
        </p>
      );
      return;
    }
    updateIngredientField("name", tempName, ingId);
    setItemName(tempName);
  }

  function onHandleUnit(val) {
    updateIngredientField("unit", val, ingId);
    setItemUnit(val);
    if (val === INVENTORY_INGREDIENT_UNIT[2].value) {
      setItemMinStock("");
    }
  }

  const handleMinStockChange = (e) => {
    const v = e.target.value;

    if (v === "") {
      setItemMinStock("");
      updateIngredientField("minStock", 0, ingId); // optional: treat empty as 0
      return;
    }

    // Check fraction restriction for "piece" unit
    if (itemUnit === INVENTORY_INGREDIENT_UNIT[2].value && !INTEGER_RE.test(v)) {
      message.warning(
        <p className="font-p_regular text-[12px]">
          You cannot add <span className="text-red-500">fraction</span> in piece.
        </p>
      );
      return;
    }

    // Validate decimal input
    if (!DECIMAL_INPUT_RE.test(v)) return;

    const numericValue = Number(v);

    // Max value check
    if (numericValue > 99999) {
      message.warning(
        <p className="font-p_regular text-[12px]">
          Minimum stock cannot be greater than <span className="text-red-500">99999</span>.
        </p>
      );
      return;
    }

    // All validations passed → update state and field
    setItemMinStock(v);
    updateIngredientField("minStock", numericValue, ingId);
  };

  const handleMinStockBlur = () => {
    // optional normalization:
    // if user typed ".5" convert to "0.5"
    if (/^\.\d{1,2}$/.test(itemMinStock)) {
      setItemMinStock("0" + itemMinStock);
    }
  };

  const handleMinStockPaste = (e) => {
    const pasted = e.clipboardData.getData("text");
    if (!DECIMAL_INPUT_RE.test(pasted)) {
      e.preventDefault();
    }
  };

  const handleMinStockKeyDown = (e) => {
    // allow navigation & control keys
    const allowedControlKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", "Home", "End"];
    if (allowedControlKeys.includes(e.key) || e.metaKey || e.ctrlKey) return;

    // allow numbers and dot only
    if (!/[0-9.]/.test(e.key)) {
      e.preventDefault();
      return;
    }

    // prevent second dot
    if (e.key === "." && e.currentTarget.value.includes(".")) {
      e.preventDefault();
    }
  };

  return (
    <section className="flex space-x-3">
      <div className="w-[300px] h-[48px]">
        <Input
          value={itemName}
          onChange={(e) => onHandleItemName(e)}
          name="itemName"
          className="w-full h-full"
          placeholder="Item name"
        />
      </div>
      <div className="w-[130px] h-[48px]">
        <Select
          disabled={Object.keys(ingredient).length > 0}
          value={itemUnit}
          style={{ width: "100%", height: "100%" }}
          onChange={onHandleUnit}
          options={INVENTORY_INGREDIENT_UNIT}
        />
      </div>
      <div className="w-[300px] ingredient-min-stock">
        <Input
          type="text"
          value={itemMinStock}
          onChange={handleMinStockChange}
          onBlur={handleMinStockBlur}
          onPaste={handleMinStockPaste}
          onKeyDown={handleMinStockKeyDown}
          name="itemName"
          className="w-full h-full"
          autoComplete="off"
          addonAfter={INVENTORY_INGREDIENT_UNIT.find((u) => u.value === itemUnit)?.label}
          placeholder="Minimum Stocks"
        />
      </div>
    </section>
  );
}
